import useLanguageRegionCode from 'hooks/useLanguageRegionCode';
import { FormattedMessage } from '@alltrails/shared/react-intl';
import Expandable from '../../../shared/Expandable';
import * as styles from './FrequentlyAskedQuestions.module.scss';

const FrequentlyAskedQuestions = () => {
  const languageRegionCode = useLanguageRegionCode();

  return (
    <section className={styles.container}>
      <h3 className={styles.header}>
        <FormattedMessage defaultMessage="Frequently asked questions" />
      </h3>
      <Expandable title={<FormattedMessage defaultMessage="How do I redeem my subscription?" />} classes={styles.expandable}>
        <div className={styles.dropdownText}>
          <FormattedMessage defaultMessage="AllTrails gift subscriptions are delivered by email. They contain a redemption code and link to redeem on the web. When redeemed, the Pro subscription will be applied to your account." />
        </div>
      </Expandable>
      <Expandable
        title={<FormattedMessage defaultMessage="Can I give a subscription to someone who already has a Pro account?" />}
        classes={styles.expandable}
      >
        <div className={styles.dropdownText}>
          <FormattedMessage defaultMessage="Yes! If your recipient has a subscription directly with AllTrails, they can redeem your gift now and it will be applied at their next renewal. If their current subscription is through Google Play or the Apple App Store, they'll need to let it expire or cancel before redeeming (unfortunately, gift subscriptions don’t work in the app stores). Luckily, they have 24 months to use the gift subscription before it expires." />
        </div>
      </Expandable>
      <Expandable title={<FormattedMessage defaultMessage="Will I know if my recipient receives their gift?" />} classes={styles.expandable}>
        <div className={styles.dropdownText}>
          <FormattedMessage defaultMessage="Absolutely. We'll send you an email notification as soon as the gift email is opened." />
        </div>
      </Expandable>
      <Expandable title={<FormattedMessage defaultMessage="The subscription I sent wasn’t received?" />} classes={styles.expandable}>
        <div className={styles.dropdownText}>
          <FormattedMessage
            defaultMessage="We can help! Please send your order confirmation number to <a>support@alltrails.com</a> and our customer support team will get to the bottom of it."
            values={{
              a: (chunks: string) => <a href={`mailto:${chunks}`}>{chunks}</a>
            }}
          />
        </div>
      </Expandable>
      <Expandable title={<FormattedMessage defaultMessage="Is there an expiration date on the subscription?" />} classes={styles.expandable}>
        <div className={styles.dropdownText}>
          <FormattedMessage defaultMessage="Yes, your recipient will have 24 months to redeem their subscription from the moment they receive the gift. Once redeemed, the code is good for the length of the subscription that was gifted. For example, if you gift someone a year subscription, that year begins whenever they redeem it." />
        </div>
      </Expandable>
      <Expandable
        title={<FormattedMessage defaultMessage="Can I buy a physical gift subscription?" />}
        classes={`${styles.expandable} ${styles.noBottomBorder}`}
      >
        <div className={styles.dropdownText}>
          {' '}
          <FormattedMessage defaultMessage="If you don't want your gift delivered by email, you'll have the option to print instead. Then you can deliver your gift by hand or by mail and the PDF will include all the information your recipient needs to redeem it." />
        </div>
      </Expandable>
      <div className={styles.needHelp}>
        <FormattedMessage
          defaultMessage="Need help? Ask at <a>support@alltrails.com</a>"
          values={{
            a: (chunks: string) => <a href={`mailto:${chunks}`}>{chunks}</a>
          }}
        />
        <br />
        <FormattedMessage
          defaultMessage="or visit our <a>Help Center</a>"
          values={{ a: (chunks: string) => <a href={`https://support.alltrails.com/hc/${languageRegionCode}`}>{chunks}</a> }}
        />
      </div>
    </section>
  );
};

export default FrequentlyAskedQuestions;
